import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { Link, useSearchParams } from 'react-router-dom';
import callAPI from "../../comps/fetch/main";
import IGPosts from "../../comps/list-ig-posts/main";
import {message, Modal} from 'antd'
import ShowPlans from "../../comps/show_plans/main";
function FBHome() {
  const [messageApi, contextHolder] = message.useMessage();

  const [searchParams] = useSearchParams();
  const [showPlanModal , setShowPlanModal] = useState(false)
  let  default_tab = searchParams.get("tab"); 
  default_tab = default_tab || "1"

  return(
    <div className="page-layout">
      {contextHolder}

      <Sider />
      <div className="page-content">
       <IGPosts fb_page={true} nextPostsAutomationLimit={0} allowMoreAutomation={true}  setShowPlanModal={setShowPlanModal} />
        </div>

        <Modal
        title="Plans"
        open={showPlanModal}
        onCancel={() => setShowPlanModal(false)}
        width='100%'
        // maxWidth='800px'
      >


        <ShowPlans messageApi={messageApi} setPaymentLinkLoading={false} setPaymentLinkData={{}} currentPlan={localStorage.getItem("planid")} />
      </Modal>
    </div>

  )

}

export default FBHome;